/**
 * Overview's own phone cut-off (BON-534).
 *
 * Deliberately wider than the app's shared `useViewport` tier. The month
 * calendar needs close to a desktop column to stay readable: seven day columns
 * plus filter chips inside a tablet width renders visibly squeezed, which is
 * what the 768px tier produced between roughly 768 and 1024. Overview therefore
 * treats everything below 1024 as a phone and shows the list layout there.
 *
 * `useViewport` keeps its 768px meaning for booking detail, which has no
 * calendar to squeeze — moving the shared tier to fix Overview would have
 * silently re-laid-out an unrelated page.
 */
import { useMediaQuery } from '../../../../hooks/useViewport';

/** Below this width Overview uses the phone layout. */
export const OVERVIEW_PHONE_MAX_PX = 1023;

export function useOverviewViewport(): { isPhone: boolean } {
  return { isPhone: useMediaQuery(`(max-width: ${OVERVIEW_PHONE_MAX_PX}px)`) };
}
